import React from 'react'
import './integration-hero.css'

const IntegrationHero = ({ 
  title, 
  subtitle, 
  description, 
  primaryCta, 
  secondaryCta, 
  backgroundImage,
  className = '' 
}) => {
  const handlePrimaryClick = (e) => {
    if (primaryCta.onClick) {
      primaryCta.onClick()
    }
  }

  return (
    <section className={`integration-hero ${className}`}>
      <div className="integration-hero-background">
        {backgroundImage && (
          <img 
            src={backgroundImage} 
            alt="" 
            className="integration-hero-bg-image"
            loading="eager"
          />
        )}
        <div className="integration-hero-gradient"></div>
      </div>
      
      <div className="integration-hero-content">
        <div className="integration-hero-center">
          <h1 className="integration-hero-title" data-aos="fade-up">
            {title}
          </h1>
          
          {subtitle && (
            <p className="integration-hero-subtitle" data-aos="fade-up" data-aos-delay="100">
              {subtitle}
            </p>
          )}
          
          {description && (
            <p className="integration-hero-description" data-aos="fade-up" data-aos-delay="200">
              {description}
            </p>
          )}
          
          <div className="integration-hero-actions" data-aos="fade-up" data-aos-delay="300">
            {primaryCta && (
              <a
                href={primaryCta.href}
                target={primaryCta.href.startsWith('http') ? '_blank' : undefined}
                rel={primaryCta.href.startsWith('http') ? 'noreferrer noopener' : undefined}
                className="integration-hero-cta primary"
                onClick={handlePrimaryClick}
              >
                {primaryCta.text}
              </a>
            )}
            
            {secondaryCta && (
              <a
                href={secondaryCta.href}
                target={secondaryCta.href.startsWith('http') ? '_blank' : undefined}
                rel={secondaryCta.href.startsWith('http') ? 'noreferrer noopener' : undefined}
                className="integration-hero-cta secondary"
              >
                {secondaryCta.text}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default IntegrationHero